// Yetkilendirme yardımcıları (Faz 54 — modül-bazlı erişim)
// Not: Eski rol seti artık kullanılmıyor; `can.*` helperları artık kullanıcının
// efektif modül erişimine bakar. Admin (role=="yonetici") her yere erişir.
export const ROLE_LABELS = {
  yonetici: "Yönetici",
  kullanici: "Kullanıcı",
  // legacy
  sef: "Kullanıcı",
  saha: "Kullanıcı",
  muhasebe: "Kullanıcı",
  salt_okur: "Kullanıcı",
  ofis: "Yönetici",
};

export const ROLE_OPTIONS = [
  { value: "yonetici", label: "Yönetici" },
  { value: "kullanici", label: "Kullanıcı" },
];

// Legacy — eski kod tabanı import edebiliyor; artık işlevsiz ama bozmasın.
export const ROLES_ALL_SITES = new Set(["yonetici"]);
export const ROLES_CAN_WRITE_MATERIAL = new Set(["yonetici", "kullanici"]);
export const ROLES_CAN_MANAGE_SUPPLIER = new Set(["yonetici", "kullanici"]);
export const ROLES_CAN_MANAGE_SITE = new Set(["yonetici"]);
export const ROLES_CAN_MANAGE_USER = new Set(["yonetici"]);
export const ROLES_READ_ONLY = new Set([]);

// Yeni helper'lar — modül erişimine bakar.
const isAdmin = (u) => !!u && (u.role || "").toLowerCase() === "yonetici";
const hasModule = (u, slug) => {
  if (!u) return false;
  if (isAdmin(u)) return true;
  const eff = Array.isArray(u.effective_module_access)
    ? u.effective_module_access
    : (Array.isArray(u.module_access) ? u.module_access : []);
  return eff.includes(slug);
};

export const can = {
  // Admin veya ilgili modüle erişen non-admin → sayfaya girebilir.
  writeMaterial: (u) => hasModule(u, "stok-yonetimi"),
  manageSupplier: (u) => hasModule(u, "tedarikci-yonetimi"),
  // Sistem/kurulum ayarları hâlâ admin'e özel.
  manageSite: (u) => isAdmin(u),
  manageUser: (u) => isAdmin(u),
  // Modül içinde her türlü işlem (silme dahil) kullanıcıya açık — module guard
  // zaten yetkisizleri sayfaya sokmaz.
  delete: (u) => !!u,
  // "Salt okur" konsepti kaldırıldı.
  readOnly: () => false,
};
